module.exports = __webpack_public_path__ + "img/centerIonc6.9c5149d2.png";